import { render } from "./QuizResultPage.vue?vue&type=template&id=216d2d6f&scoped=true"
import script from "./QuizResultPage.vue?vue&type=script&lang=js"
export * from "./QuizResultPage.vue?vue&type=script&lang=js"

import "./QuizResultPage.vue?vue&type=style&index=0&id=216d2d6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216d2d6f"]])

export default __exports__